var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocalizing = function SvgLocalizing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4a1.5 1.5 0 0 0 0 3H19v1.502c0 .77-.194 1.358-.454 1.71-.222.302-.526.494-1.03.494a1.5 1.5 0 1 0 0 3 4.16 4.16 0 0 0 3.448-1.718c.734-1 1.036-2.264 1.036-3.486V5.5A1.5 1.5 0 0 0 20.5 4zm-2.104 5.45a1.5 1.5 0 0 0-2.792 0l-6.508 16.5a1.5 1.5 0 1 0 2.79 1.1l1.598-4.048h7.026l1.594 4.048a1.5 1.5 0 0 0 2.792-1.1zm.932 10.552h-4.66L12 14.09zM25.5 4A1.5 1.5 0 0 1 27 5.5v4.496h.5a1.5 1.5 0 1 1 0 3H27v7.502a1.5 1.5 0 1 1-3 0V5.5A1.5 1.5 0 0 1 25.5 4"
  })));
};
export default SvgLocalizing;